import { adjustmentSessionIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const findAdjustmentSessionBySource = {
  name: "findAdjustmentSessionBySource" as const,
  input: z.object({ sourceId: z.string() }),
  output: z.object({ sessionId: adjustmentSessionIdFormat.schema.nullable() }),
};
